// fallow-ignore-file
import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  type SupplierContact,
  type UpsertSupplierContactPayload,
} from '../types';
import {
  zodSupplierContactSchema,
  zodUpsertSupplierContactPayloadSchema,
} from '../validations';

/**
 * Creates a new contact for a supplier relationship.
 *
 * @param deId - The data exchange ID of the supplier relationship.
 * @param payload - The contact data to create.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The created supplier contact.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-details/operation/create_supplier_contact_suppliers_details__de_id__contacts_post
 */
export const createSupplierContact = async (
  deId: UUID,
  payload: UpsertSupplierContactPayload,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .post(ENDPOINT.SUPPLIER.CREATE_CONTACT(deId), {
      ...options,
      json: payload,
      validate: {
        body: zodUpsertSupplierContactPayloadSchema,
        response: zodSupplierContactSchema,
      },
    })
    .json<SupplierContact>();
